<template>
  <div v-if="sidebar" class="fixed inset-0 z-50">
    <button
      class="absolute inset-0 bg-slate-900/60 backdrop-blur-[2px]"
      @click="closeSidebar()"
      aria-label="Kapat"
    ></button>

    <aside
      class="fixed inset-y-0 right-0 w-full md:w-[920px] lg:w-[1120px] bg-slate-50 shadow-2xl flex flex-col"
    >
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div class="min-w-0">
          <div class="text-xs uppercase tracking-[0.3em] text-slate-400">Otel detaylari</div>
          <div v-if="isLoading" class="mt-2 h-5 w-48 rounded-full bg-slate-200 animate-pulse"></div>
          <div v-else class="text-lg font-semibold text-slate-900 truncate" v-html="hoteldata?.sOtelAdi?.tr"></div>
        </div>
        <button
          class="h-10 w-10 rounded-full border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-300"
          @click="closeSidebar()"
          aria-label="Kapat"
        >
          <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon>
        </button>
      </div>

      <div v-if="isLoading" class="flex-1 overflow-y-auto">
        <div class="px-6 pt-6 pb-8 space-y-6 animate-pulse">
          <div class="relative overflow-hidden rounded-2xl bg-slate-200">
            <div class="h-[240px] w-full md:h-[300px] bg-gradient-to-br from-slate-200 via-slate-100 to-slate-300"></div>
            <div class="absolute inset-0 bg-gradient-to-t from-slate-950/35 via-slate-950/5 to-transparent"></div>
            <div class="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2">
              <div class="h-7 w-24 rounded-full bg-white/30"></div>
              <div class="h-7 w-20 rounded-full bg-white/25"></div>
              <div class="h-7 w-28 rounded-full bg-white/20"></div>
            </div>
          </div>

          <div class="flex flex-wrap gap-2 text-sm">
            <div class="h-10 w-32 rounded-full bg-slate-200"></div>
            <div class="h-10 w-24 rounded-full bg-slate-200"></div>
            <div class="h-10 w-24 rounded-full bg-slate-200"></div>
            <div class="h-10 w-24 rounded-full bg-slate-200"></div>
          </div>

          <div class="grid gap-4">
            <div class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100 space-y-4">
              <div class="h-3 w-24 rounded-full bg-slate-200"></div>
              <div class="space-y-3">
                <div class="h-3 w-full rounded-full bg-slate-100"></div>
                <div class="h-3 w-11/12 rounded-full bg-slate-100"></div>
                <div class="h-3 w-10/12 rounded-full bg-slate-100"></div>
              </div>
            </div>

            <div class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100 space-y-4">
              <div class="h-3 w-28 rounded-full bg-slate-200"></div>
              <div class="space-y-3">
                <div class="flex items-center justify-between gap-6">
                  <div class="h-3 w-24 rounded-full bg-slate-100"></div>
                  <div class="h-3 w-28 rounded-full bg-slate-100"></div>
                </div>
                <div class="flex items-center justify-between gap-6">
                  <div class="h-3 w-24 rounded-full bg-slate-100"></div>
                  <div class="h-3 w-20 rounded-full bg-slate-100"></div>
                </div>
                <div class="flex items-start justify-between gap-6">
                  <div class="h-3 w-16 rounded-full bg-slate-100 mt-1"></div>
                  <div class="h-3 w-44 rounded-full bg-slate-100"></div>
                </div>
              </div>
            </div>

            <div class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100 space-y-4">
              <div class="h-3 w-24 rounded-full bg-slate-200"></div>
              <div class="space-y-3">
                <div class="h-3 w-full rounded-full bg-slate-100"></div>
                <div class="h-3 w-11/12 rounded-full bg-slate-100"></div>
                <div class="h-3 w-9/12 rounded-full bg-slate-100"></div>
                <div class="h-3 w-10/12 rounded-full bg-slate-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="hoteldata?.hotelId" class="flex-1 overflow-y-auto">
        <TourFeaturedHotelExperience
          v-if="isFeaturedHotel"
          :hotel="hoteldata"
          :gallery="hotelsGallery"
        />
        <template v-else>
        <div class="px-6 pt-6">
          <div class="relative overflow-hidden rounded-2xl bg-slate-200">
            <img
              v-if="hotelsGallery && hotelsGallery.length"
              :src="showImage(hoteldata.sOtelPhoto, 1600, 900, true, 90)"
              :alt="hoteldata.sOtelAdi?.tr || hoteldata.sOtelAdi?.en || 'Umre oteli'"
              class="h-[240px] w-full object-cover md:h-[300px]"
            />
            <div v-else class="h-[240px] w-full md:h-[300px] bg-gradient-to-br from-slate-200 to-slate-300"></div>
            <div class="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-950/10 to-transparent"></div>
            <div class="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2 text-white">
              <span class="rounded-full bg-white/10 px-3 py-1 text-xs uppercase tracking-[0.2em]">{{ hoteldata.city?.tr }}</span>
              <span class="rounded-full bg-white/10 px-3 py-1 text-xs uppercase tracking-[0.2em]">{{ hoteldata.star?.tr }}</span>
              <span v-if="hoteldata.od_Adres?.tr" class="rounded-full bg-white/10 px-3 py-1 text-xs">
                {{ hoteldata.od_Adres?.tr }}
              </span>
            </div>
          </div>

          <div class="mt-6 flex flex-wrap gap-2 text-sm">
            <button
              class="rounded-full px-4 py-2 border transition"
              :class="tab == 'general' ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-200 text-slate-600 hover:border-slate-300'"
              @click="tab = 'general'"
            >
              Genel Bilgi
            </button>
            <button
              class="rounded-full px-4 py-2 border transition"
              :class="tab == 'gallery' ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-200 text-slate-600 hover:border-slate-300'"
              @click="tab = 'gallery'"
            >
              Galeri
            </button>
            <button
              v-show="hoteldata.hotelVideo"
              class="rounded-full px-4 py-2 border transition"
              :class="tab == 'video' ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-200 text-slate-600 hover:border-slate-300'"
              @click="tab = 'video'"
            >
              Video
            </button>
            <button
              class="rounded-full px-4 py-2 border transition"
              :class="tab == 'map' ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-200 text-slate-600 hover:border-slate-300'"
              @click="tab = 'map'"
            >
              Harita
            </button>
          </div>
        </div>

        <div class="px-6 pb-8">
          <template v-if="tab == 'general'">
            <div class="mt-6 grid gap-4">
              <div v-if="hoteldata.sOtelShort?.tr" class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
                <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Ozet</div>
                <div class="mt-2 text-base text-slate-800">{{ hoteldata.sOtelShort?.tr }}</div>
              </div>
              <div class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
                <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Temel bilgiler</div>
                <div class="mt-3 grid gap-2 text-sm text-slate-700">
                  <div class="flex items-center justify-between border-b border-slate-100 pb-2">
                    <span class="font-medium">Otel Yildizi</span>
                    <span>{{ hoteldata.star?.tr }}</span>
                  </div>
                  <div class="flex items-center justify-between border-b border-slate-100 pb-2">
                    <span class="font-medium">Otel Sehir</span>
                    <span>{{ hoteldata.city?.tr }}</span>
                  </div>
                  <div v-if="hoteldata.od_Adres?.tr" class="flex items-start justify-between gap-6">
                    <span class="font-medium">Adres</span>
                    <span class="text-right">{{ hoteldata.od_Adres?.tr }}</span>
                  </div>
                </div>
              </div>
              <div class="rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
                <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Aciklama</div>
                <div class="mt-2 text-sm text-slate-700" v-html="HtmlEncode(hoteldata.first?.tr)"></div>
              </div>
            </div>
          </template>

          <template v-if="tab == 'video'">
            <div v-if="hoteldata.hotelVideo" class="mt-6 rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
              <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Tanitim videosu</div>
              <div class="mt-4 overflow-hidden rounded-xl bg-slate-200 relative">
                <iframe
                  :width="isMobile ? '345' : '800'"
                  :height="isMobile ? '220' : '420'"
                  :src="hoteldata.hotelVideo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  class="w-full"
                ></iframe>
                <div class="pointer-events-none absolute bottom-3 right-3 z-10 rounded-md bg-white/70 border border-white/80 px-1.5 py-1 shadow-md">
                  <img src="/assets/img/logo/logo_inanc.jpg" alt="Inanc Tur Brandmark" class="w-[70px] h-auto object-contain opacity-90" />
                </div>
              </div>
            </div>
          </template>

          <template v-if="tab == 'gallery'">
            <div v-if="hotelsGallery" class="mt-6 rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
              <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Foto galeri</div>
              <div class="mt-4">
                <Carousel :itemsToShow="1" :wrap-around="true" v-model="currentSlide" class="my-0 py-0">
                  <Slide v-for="(slide, index) in hotelsGallery" :key="slide">
                    <div class="carousel__item relative group">
                      <div>
                        <template v-if="slide.video">
                          <div class="relative">
                            <iframe
                              :width="isMobile ? '345' : '800'"
                              :height="isMobile ? '220' : '420'"
                              :src="slide.video"
                              title="YouTube video player"
                              frameborder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerpolicy="strict-origin-when-cross-origin"
                              allowfullscreen
                            ></iframe>
                            <div class="pointer-events-none absolute bottom-3 right-3 z-10 rounded-md bg-white/70 border border-white/80 px-1.5 py-1 shadow-md">
                              <img src="/assets/img/logo/logo_inanc.jpg" alt="Inanc Tur Brandmark" class="w-[70px] h-auto object-contain opacity-90" />
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <img :src="showImage(slide.i, 1280, 800, true, 90)" :alt="slide.name || hoteldata.sOtelAdi?.tr || 'Umre oteli görseli'" class="rounded-xl" />
                          <div class="text-xs absolute bg-slate-900/70 px-2 py-1 rounded-full top-4 right-4 text-white">
                            {{ slide.name }}
                          </div>
                          <a class="absolute top-4 left-4" @click="selectedIndex = index">
                            <font-awesome-icon icon="fa-solid fa-arrows-h" class="text-white h-5 w-5 rotate-45"></font-awesome-icon>
                          </a>
                        </template>
                      </div>
                    </div>
                  </Slide>
                </Carousel>
                <Suspense>
                  <TourLazyGalleryViewer
                    v-if="hotelsGallery && hotelsGallery.length > 0 && typeof selectedIndex == 'number' && selectedIndex >= 0"
                    :selectedIndex="selectedIndex"
                    :images="hotelsGallery"
                    @close="selectedIndex = null"
                    @setIndex="event => selectedIndex = event"
                  ></TourLazyGalleryViewer>
                </Suspense>
                <div class="mt-4">
                  <Carousel
                    id="thumbnails"
                    :items-to-show="isMobile ? 4 : 9"
                    :wrap-around="true"
                    v-model="currentSlide"
                    ref="carousel"
                    class="my-0 py-0"
                  >
                    <Slide v-for="(slide, index) in hotelsGallery" :key="slide">
                      <div class="carousel__item border-slate-200 border cursor-pointer group rounded-lg overflow-hidden" @click="slideTo(index)">
                        <img :src="slide.video ? slide.i : showImage(slide.i, 280, 160, true, 90)" :alt="slide.name || `${hoteldata.sOtelAdi?.tr || 'Umre oteli'} galeri görseli ${index + 1}`" />
                      </div>
                    </Slide>
                  </Carousel>
                </div>
              </div>
            </div>
          </template>

          <template v-if="tab == 'map'">
            <div class="mt-6 rounded-2xl bg-white p-5 shadow-sm border border-slate-100">
              <div class="flex items-center justify-between">
                <div class="text-xs uppercase tracking-[0.2em] text-slate-400">Konum</div>
                <div v-if="hoteldata.od_Adres?.tr" class="text-xs text-slate-500">{{ hoteldata.od_Adres?.tr }}</div>
              </div>
              <div class="mt-4" id="maps">
                <div v-if="hoteldata.sOtel_Konum" class="h-[60vh] min-h-[420px] overflow-hidden rounded-xl border border-slate-100">
                  <Suspense>
                    <TourGoogleMap :location1="hoteldata.sOtel_Konum" :hotel="hoteldata" :zoom="16"></TourGoogleMap>
                  </Suspense>
                </div>
                <div v-else class="rounded-xl border border-dashed border-slate-200 p-6 text-sm text-slate-500">
                  Konum bilgisi bulunamadi.
                </div>
              </div>
            </div>
          </template>
        </div>
        </template>
      </div>

      <div v-else class="flex-1 overflow-y-auto px-6 py-8">
        <div class="rounded-3xl border border-dashed border-slate-200 bg-white/80 p-8 text-center">
          <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
            <font-awesome-icon icon="fa-solid fa-hotel" class="h-5 w-5"></font-awesome-icon>
          </div>
          <div class="mt-4 text-lg font-semibold text-slate-900">Otel detayı bulunamadı</div>
          <div class="mt-2 text-sm text-slate-500">Lütfen tekrar deneyin veya farklı bir otel seçin.</div>
        </div>
      </div>
    </aside>
  </div>
  <div v-else></div>
</template>
<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue';
import axios from "axios";
import { Carousel, Pagination, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
 
const { goPath, showImage,HtmlEncode } = useCommon();
const isMobile = useIsMobile();
const currentSlide = ref(0)
const selectedIndex = ref(null)
const tab = ref('general') 
const emit = defineEmits(["close"]);
const config = useRuntimeConfig();

const props = defineProps({
    hotelId:{
        type:String
    }
})
  const sidebar = ref(false);
  const hoteldata = ref(null);
  const isLoading = ref(false);

const featuredHotelIds = new Set([
  'aG90ZWxEZXRhaWwxNzI4NTQ4MjA3',
  'aG90ZWxEZXRhaWwxNTI2NDU3NTk2',
  'aG90ZWxEZXRhaWwxNzc2NTkwNzI1',
  'ROTANAJABALOMAR'
])
const isFeaturedHotel = computed(() => featuredHotelIds.has(hoteldata.value?.hotelId))
 
  const openHotelDetail = async (hotel)=>{ 
    const hotelId = typeof hotel === 'string' ? hotel : hotel?.hotelId;
    if (!hotelId) {
      return;
    }

    console.log("hotel",hotel)
    sidebar.value = true; 
    tab.value = 'general';
    isLoading.value = true;
    hoteldata.value = null;

    try {
      await getHotel(hotelId)
    } finally {
      isLoading.value = false;
    }
    }

    const getHotel =async (pid)=> {
 
 //const baseURL = "https://api3.fatihd.com/api/";


await axios({
     url: `${config.public.apiBase}`+"/graphql/direct",
     method: 'post',  
     data: {
         query: `
         {
             hotel(id: "`+pid+`"){ 
               hotelId,
                 sOtelAdi{
                 tr
               },
            
               sOtelPhoto, 
               hotelVideo,
               h_hotelCity,
               city{
                 tr
               },star{
                 tr
               },
               hPhotoGallery,
                sOtelFirstV,
                first{
                 tr
               },
               sOtelFeatures,
               sOtelCate,
               sOtelSpec{  tr },
               hoteDetails{ tr  },
               sOtel_Notes{tr},
               sOtel_Food{tr},
               sOtel_Pools{tr},
               od_ikons,
               od_giris,
               od_cikis,
               od_Adres{
                 tr
               },
               sOtel_Konum
               
               
             }
           } 
     `
     // od_giris,
     //           od_cikis,
     //           od_Konum,
     //           od_Adres,
     //           od_Ulasim
     }
 }).then(response => {
    //  console.log(response.data.data.hotel[0])
     let donen = {};
     donen = response.data.data.hotel[0]
     hoteldata.value = donen;

 }).catch(e => {
     console.log(e)
   hoteldata.value = null;
 })

};


const hotelsGallery = computed(() => {
  let images = []
  if (hoteldata.value) { 
     let item = hoteldata.value;
      if (item.hotelVideo) {
        //images.push({ i: 'https://yonetim.inanctur.com.tr/visual2/yonetim/' + img.i, t: img.t, name: item.sOtelAdi?.tr })
        images.push({ i: '/assets/img/video-play.png', video: item.hotelVideo, name: item.sOtelAdi?.tr })
      }
      if (item.hPhotoGallery && item.hPhotoGallery.charAt(0) == "{") {
        let gallery = JSON.parse(item.hPhotoGallery);
        if (Array.isArray(gallery)) {

        } else if (typeof gallery == "object") {

          gallery = Object.values(gallery)

        }
        if (gallery && gallery[0]) {
          gallery.forEach(img => {
            images.push({ i: 'https://image.inanctur.com.tr/yonetim/' + img.i, t: img.t, name: item.sOtelAdi?.tr })

          })
        }
      } 
  }

 
  return images;
});



const slideTo = (val) => {
  //console.log("hotelsGallery", hotelsGallery.value, val)
  currentSlide.value = val
};

const addScript = async (url)=>{
                var script = document.createElement('script');
            script.type = 'application/javascript';
            script.src = url;
            await document.head.appendChild(script);
}
onMounted(async () => {
  if(typeof google == "undefined" || !google || (google && !google.maps)){
      await addScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyD08hQnRH1BlCOQpFCm6OcSBoNanxj2_HY")
  }
});
const changeVisibility = (hotelId,visibility)=>{

    if(hotelId){
        sidebar.value = true;
        openHotelDetail(hotelId)
    }else{
        sidebar.value = false;
    }
    
}
const  closeSidebar = ()=>{
  sidebar.value=false;
  emit("close",true)
}
defineExpose({
    changeVisibility
})
</script>
